import { useMemo } from 'react';
import { useRecoilState } from 'recoil';
import dayjs from 'dayjs';
import { Modal } from '@mui/material';
import { TaskItem } from '@demind-inc/core';

import { CreateEventMenu } from '../CalendarView/EventMenu/CreateEventMenu';
import CoreActionModal from '../KanbanView/CoreActions/CoreActionModal/CoreActionModal';
import EditSleepModalView from '../KanbanView/CoreActions/CoreActionModal/ActionModalViews/EditSleepModalView/EditSleepModalView';
import TaskDetailModal from '../TaskDetailModal/TaskDetailModal';
import {
  DEFAULT_TASK_DURATION_MIN,
  quickActionSleepModalAtom,
  quickActionTaskCreateAtom,
  useCreateEventMenuContext,
} from '../../data-access';

const SideNavigationQuickActionModals = () => {
  const { creatingEvent, clearCreatingEvent } = useCreateEventMenuContext();
  const [isCreatingTask, setIsCreatingTask] = useRecoilState(quickActionTaskCreateAtom);
  const [isSleepModalOpen, setIsSleepModalOpen] = useRecoilState(quickActionSleepModalAtom);

  const emptyTask = useMemo<TaskItem>(
    () =>
      ({
        name: '',
        desc: '',
        dueDateTime: {
          date: dayjs().format('YYYY-MM-DD'),
          timezone: dayjs.tz.guess(),
        },
        duration: { amount: DEFAULT_TASK_DURATION_MIN, unit: 'minute' },
        labels: [],
        subTasks: [],
        completed: false,
        rawJson: {},
      }) as TaskItem,
    [isCreatingTask]
  );

  return (
    <>
      {creatingEvent && (
        <CreateEventMenu visible={!!creatingEvent} onClose={clearCreatingEvent} />
      )}
      {isCreatingTask && (
        <TaskDetailModal
          visible={isCreatingTask}
          task={emptyTask}
          isCreateMode
          onClose={() => setIsCreatingTask(false)}
        />
      )}
      <Modal open={isSleepModalOpen} onClose={() => setIsSleepModalOpen(false)}>
        <EditSleepModalView onClose={() => setIsSleepModalOpen(false)} />
      </Modal>
      <CoreActionModal />
    </>
  );
};

export default SideNavigationQuickActionModals;
